export default __webpack_public_path__ + "static/media/pinkpic.05f162c0.jpg";